import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, unref as _unref, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

import { debounce, isNumber } from "lodash";
  import { format_currency } from "@/utils/currencies";
  import { nextTick, onMounted, reactive, ref, watch } from "vue";
  import { ILot } from "@/models";
  import Swiper from "@/components/_partials/Swiper.vue";

  
export default /*#__PURE__*/_defineComponent({
  __name: 'SelectBidDropdown',
  props: {
    lotData: {},
    userBidProp: {},
    currentBidProp: {},
    bidsCountProp: {},
    dropdownCustomClass: {},
    directionVerticalProp: { default: "bottom" },
    isChangeDirection: { type: Boolean, default: true }
  },
  emits: ["update:selectedBid"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

  const emit = __emit;

  const props = __props;

  const state = reactive({
    lotId: props.lotData.id,
    bidVariants: props.lotData.bid_variants,
    selectedBid: 0,
    userBid: props.userBidProp,
    currentBid: props.currentBidProp,
    bidsCount: props.bidsCountProp,
    isOpen: false,
    isSwiperInit: false,
    isInvertDropdown: false,
    activeSlideIndex: null
  });

  const swiperCp = ref<unknown>(null);
  const listWrapper = ref<HTMLDivElement>(null);

  watch(
    () => state.selectedBid,
    (newValue) => {
      emit("update:selectedBid", newValue);
    }
  );

  watch(
      () => props.userBidProp,
      (newValue) => (state.userBid = newValue)
  );

  watch(
      () => state.userBid,
      () => {
        refreshBidVariants();
        state.selectedBid = state.bidVariants[0];
      }
  );

  watch(
    () => props.currentBidProp,
    (newValue) => (state.currentBid = newValue)
  );

  watch(
    () => state.currentBid,
    () => {
      refreshBidVariants();
      state.selectedBid = state.bidVariants[0];
    }
  );

  watch(
    () => props.bidsCountProp,
    (newValue) => (state.bidsCount = newValue)
  );

  watch(
    () => state.bidsCount,
    () => {
      refreshBidVariants();
      state.selectedBid = state.bidVariants[0];
    }
  );

  onMounted(() => {
    refreshBidVariants();
    state.selectedBid = state.bidVariants[0];

    state.isInvertDropdown = props.directionVerticalProp === "top";
  });

  const updateSlideIndex = debounce((index) => {
    if (index >= state.bidVariants.length - 32) {
      addLotBidVariants();
      filterBidVariants();
      swiperCp.value.update();
    }
  }, 200);

  const initSwiper = (sw) => {
    swiperCp.value = sw;
  };

  const refreshBidVariants = () => {
    const minSelectedBidValue = state.userBid ? Math.max(state.userBid, state.currentBid) : state.currentBid;

    let maxAvailableVariant = state.bidVariants[state.bidVariants.length - 1];
    while (minSelectedBidValue > maxAvailableVariant) {
      addLotBidVariants();
      maxAvailableVariant = state.bidVariants[state.bidVariants.length - 1];
    }

    filterBidVariants();
  };
  const filterBidVariants = () => {
    const bidOnStartingPrice = props.lotData.bid_on_starting_price ?? 0;
    const startingPrice = props.lotData.starting_price ?? 0;
    const currentBid = state.currentBid ?? 0;
    const bidsCount = state.bidsCount ?? 0;
    const userBid = state.userBid ?? 0;

    if (bidOnStartingPrice && currentBid === startingPrice && bidsCount === 0) {
      state.bidVariants = state.bidVariants.filter((item) => item >= currentBid && item > userBid);
    } else {
      state.bidVariants = state.bidVariants.filter((item) => item > currentBid && item > userBid);
    }
  };
  const toggleDropdown = () => {
    state.isOpen = !state.isOpen;

    if (state.isOpen && !state.isSwiperInit) {
      state.isSwiperInit = true;
    }

    if (props.isChangeDirection) {
      state.isInvertDropdown = true;
      // state.isInvertDropdown = !isElementXPercentInViewport(listWrapper.value, 100);
    }

    if (state.isOpen && state.bidVariants.length < 50) {
      addLotBidVariants();
      filterBidVariants();
    }
  };

  const selectItem = (item) => {
    state.selectedBid = item;
    state.isOpen = false;
  };

  const addLotBidVariants = () => {
    let newVariant = Math.max(...state.bidVariants);
    let infiniteStep = props.lotData.bid_infinite_step;

    for (let i = 0; i < 50; i++) {
      newVariant += infiniteStep;
      state.bidVariants.push(newVariant);
    }

    if (swiperCp.value?.activeIndex >= 0) {
      const swiperActiveIndex = swiperCp.value.activeIndex;
      nextTick(() => {
        swiperCp.value.slideTo(swiperActiveIndex);
      });
    }
  };

  const isElementXPercentInViewport = (el, percentVisible) => {
    let rect = el.getBoundingClientRect(),
      windowHeight = window.innerHeight || document.documentElement.clientHeight;

    return !(
      Math.floor(100 - ((rect.top >= 0 ? 0 : rect.top) / +-rect.height) * 100) < percentVisible ||
      Math.floor(100 - ((rect.bottom - windowHeight) / rect.height) * 100) < percentVisible
    );
  };
  const formatCurrency = (amount) => {
    return format_currency(amount);
  };

  __expose({
    selectItem
  });

return (_ctx: any,_cache: any) => {
  const _component_swiper_slide = _resolveComponent("swiper-slide")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass([
      'custom-dropdown',
      'bid-dropdown',
      props.dropdownCustomClass,
      { 'dropdown-open': state.isOpen },
      { 'direction-top': state.isInvertDropdown }
    ]),
      onClick: _withModifiers(toggleDropdown, ["self"])
    }, [
      _createElementVNode("div", {
        class: "current-item",
        onClick: toggleDropdown
      }, [
        _createElementVNode("span", null, _toDisplayString(formatCurrency(state.selectedBid)), 1)
      ]),
      _createElementVNode("div", {
        class: "hidden-list-wrapper",
        ref_key: "listWrapper",
        ref: listWrapper
      }, null, 512),
      _createElementVNode("div", {
        class: _normalizeClass(['custom-scrollbar-wrapper', 'scroller-fast-bid', 'dropdown-list', { open: state.isOpen }])
      }, [
        (state.isSwiperInit)
          ? (_openBlock(), _createBlock(Swiper, {
              key: 0,
              scrollbar: true,
              navigation: false,
              mousewheel: { enabled: true, thresholdDelta: 0, thresholdTime: 0.1 },
              "check-active-index": true,
              "slides-per-view": 8,
              "slides-per-group": 8,
              speed: 1,
              direction: "vertical",
              type: "selectBidDropdown",
              onUpdateActiveSlideIndex: _cache[0] || (_cache[0] = (i) => _unref(updateSlideIndex)(i)),
              onSwiperInit: initSwiper,
              ref: "swiper"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.bidVariants, (variant) => {
                  return (_openBlock(), _createBlock(_component_swiper_slide, {
                    key: variant,
                    onClick: ($event: any) => (selectItem(variant)),
                    class: _normalizeClass(['dropdown-item', { current: state.selectedBid === variant }])
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(formatCurrency(variant)), 1)
                    ]),
                    _: 2
                  }, 1032, ["onClick", "class"]))
                }), 128))
              ]),
              _: 1
            }, 512))
          : _createCommentVNode("", true)
      ], 2)
    ], 2),
    (state.isOpen)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "modal-overlay",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (state.isOpen = false))
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})